
import Vue from "vue"
import Component from "vue-class-component"
import {Inject} from "vue-property-decorator"
import {AuthenticationService} from "@/AuthenticationService"
import _ from "lodash"

@Component
export default class Login extends Vue {
  private static readonly JWT_ERROR_COOKIE_NAME = "AUTH-ERROR"

  @Inject()
  authenticationService: AuthenticationService

  username: string = <any>null
  password: string = <any>null
  email: string = <any>null
  mfaCode: string = <any>null

  isPlainTextPassword: boolean = <any>null

  loginFormActive = true
  forgotAccountFormActive = false
  mfaRequired = false

  private message = ""
  private resetMessage = ""
  private isLoading = false

  private tryAgainCounter = 5

  async created() {
    console.log("Login View created")

    // Watch so it supports the scenario where login is being loaded and
    // authentication status is still unknown. It should only call a logout
    // (and hit the backend) if it's already logged in otherwise it will always
    // call a logout even when members first visit the page.
    this.$watch(
      () => this.$app.isAuthenticated,
      async newValue => {
        if (newValue === true) {
          // Force a logout
          // Note that the general app logout relies on this behaviour
          console.log("Forcing logout for fresh login")
          await this.authenticationService.logout()
        }
      },
      {immediate: true}
    )

    // this.$watch(
    //   () => this.$app.isServerUnavailable,
    //   this.onServerUnavailableChange,
    //   {immediate: true}
    // )

    this.checkForStaffAuthError()
  }

  async login(event: Event) {
    event.preventDefault()

    this.message = "" // Reset the message
    this.isLoading = true

    await this.authenticationService
      .authenticate(this.username, this.password, this.mfaCode)
      .then(result => {
        console.log("Authentication result:", result)
        this.mfaRequired = false
      })
      .catch(error => {
        if (error.message === "MFA required") {
          this.mfaRequired = true
        } else {
          this.message = error.message
        }
      })

    this.isLoading = false
  }

  async requestPasswordReset(event: Event) {
    event.preventDefault()
    this.resetMessage = await this.authenticationService.requestPasswordReset(this.email)
  }

  private checkForStaffAuthError() {
    if (Vue.$cookies.isKey(Login.JWT_ERROR_COOKIE_NAME)) {
      this.message = decodeURI(Vue.$cookies.get(Login.JWT_ERROR_COOKIE_NAME)).replace(/\+/g, " ")
      Vue.$cookies.remove(Login.JWT_ERROR_COOKIE_NAME)
    }
  }

  private async onServerUnavailableChange(isServerUnavailable: boolean) {
    if (isServerUnavailable) {
      const initialCounter = this.tryAgainCounter

      const checkSeverIsAvailable = async () => {
        let success = false

        if (this.tryAgainCounter === 1) {
          try {
            // Try to hit the server
            await this.authenticationService.logout()
            success = true
          } catch {
            this.tryAgainCounter = initialCounter
          }
        } else {
          this.tryAgainCounter--
        }

        if (!success) {
          setTimeout(checkSeverIsAvailable, 15000)
        }
      }

      await checkSeverIsAvailable()
    }
  }

  get staffSsoUrl(): string {
    const url = "/api/authentication/staff"
    const redirect = <string | null>this.$route.query.redirect
    return url + (_.isEmpty(redirect) ? "" : `?redirect=${redirect!}`)
  }
}
